import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearFilters } from "../../features/filter/filterSlice";
import { fetchTags } from "../../features/tags/tagsSlice";
import Tag from "./Tag";

const Tags = () => {
    const dispatch = useDispatch();
    const { tags } = useSelector((state) => state.tags);
    const { videos } = useSelector((state) => state.videos);
    const {
        tags: filterTags,
        searchText,
        author,
    } = useSelector((state) => state.filter);
    const [showClearBtn, setShowClearBtn] = useState(false);

    useEffect(() => {
        dispatch(fetchTags());

        /* Checking whether tags, search and authors are exist in the filter slice,
        then hide or show clear filter button */
        if (
            filterTags?.length > 0 ||
            searchText?.length > 0 ||
            author.length > 0
        ) {
            setShowClearBtn(true);
        } else {
            setShowClearBtn(false);
        }
    }, [dispatch, filterTags, searchText, author, videos]);

    const handleClearFilters = () => {
        dispatch(clearFilters());
    };

    return tags.length > 0 ? (
        <section>
            <div className="max-w-7xl mx-auto px-5 py-6 lg:px-0 flex gap-2 border-b overflow-y-auto">
                {tags.map((tag) => (
                    <Tag key={tag.id} title={tag.title} />
                ))}
            </div>
            <div className="text-end pt-5 px-8">
                {showClearBtn ? (
                    <button
                        onClick={handleClearFilters}
                        className="text-end bg-red-400 text-white px-2 py-1 rounded-sm"
                    >
                        Clear Filter
                    </button>
                ) : null}
            </div>
        </section>
    ) : null;
};

export default Tags;
